import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

let listeners = [];
let globalDuration = '00:00:00';
let globalInterval = null;

const startGlobalTimer = startTime => {
   if (globalInterval) clearInterval(globalInterval);

   const update = () => {
      const diff = Math.max(Date.now() - startTime, 0);
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      globalDuration = [
         hours.toString().padStart(2, '0'),
         minutes.toString().padStart(2, '0'),
         seconds.toString().padStart(2, '0'),
      ].join(':');

      listeners.forEach(listener => listener(globalDuration));
   };

   update(); // Make sure the first render is immediately accurate
   globalInterval = setInterval(update, 1000);
};

const stopGlobalTimer = () => {
   if (globalInterval) clearInterval(globalInterval);
   globalInterval = null;
   globalDuration = '00:00:00';
};

export default function useCallTimer() {
   const [duration, setDuration] = useState(globalDuration);
   const callConnectionTime = useSelector(state => state.callkitData?.callConnectionTime);

   useEffect(() => {
      const listener = newDuration => setDuration(newDuration);
      listeners.push(listener);

      // We use `callConnectionTime` if present so it shares exact start time
      // Otherwise fallback to Date.now() for older parts of the app that don't pass it
      const startTime = callConnectionTime || Date.now();

      if (!globalInterval) {
         startGlobalTimer(startTime);
      } else {
         // Just ensure state is perfectly in sync on mount
         setDuration(globalDuration);
      }

      return () => {
         listeners = listeners.filter(l => l !== listener);
         if (listeners.length === 0) stopGlobalTimer();
      };
   }, [callConnectionTime]);

   return duration;
}
